import React from "react"
import Popup from "./Popup"
import Container from "./Container"
import Dropdown from "./Dropdown"
import Searchbar from "./Searchbar"
import { useState,useEffect} from "react"
import { useReducer } from 'react';
import {reducer, initialState} from '../reducers/reducers'
import Button from "./Button"
import Table1 from "./Table1"
import EditText from "./EditText"
import SearchClient from "./SearchClient"
import SearchClaimTicket from "./SearchClaimTicket"
import API_URLS from "../Urls"
import DropdownSearch from "./DropdownSearch"

//TODO: Agregar permisos para ver el boton de agregar
const NewBudget =({onClose,onAccept})=>{
    const [saleorRepair,setSaleorRepair] = useState('Reparacion');
    const year = new Date().getFullYear()
    const [selectedItem,setSelectedItem] =useState({}) //selected 
    const [num,setNum] = useState('000')
    const [discount, setDiscount] = useState(0)
    
    const [total,setTotal] =useState(0)
    const [rawTotal,setRawTotal] =useState(0)
    const [folio,setFolio] = useState(['R','C'])
    const [client,setClient] = useState(0)
    const [type,setType] = useState('Comercial') //if the budget is enterprise or comercial
    const [itemList,setItemList] = useState([]) //items selected for the budget
    const [fetchedTypes,setFetchedTypes] = useState([]) //options for the first dropdown to add the item to the itemlist
    const [fetchedItems,setFetchedItems ] = useState([]) //options for the second dropdwon
    const [claimTicket,setClaimTicket] = useState(0)
    
    const today = new Date()
    const formattedDate = today.toISOString().split('T')[0];
      const fetchData =(url,onSuccesful)=>{
        console.log(url)
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }})
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
          console.log(data)
          if (typeof onSuccesful === 'function') onSuccesful(data) })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));}
    const updatePosition = (index, newValue) => {
        setFolio((prevArray) =>
          prevArray.map((item, i) => (i === index ? newValue : item))
        );
      };
    const setSaleRepair = (option) => {
        if(option=='Reparacion'){
            
            return (
                <SearchClaimTicket onDeselected={()=>{setClaimTicket(0);setItemList([])}} onSelected={data=>{setClaimTicket(data["id"]);
                                                                                            setClient(data["cliente"]);
                                                                                            setType(data['tipo']);
                                                                                            }}></SearchClaimTicket>
            )
        } else {
           
            return(
                <SearchClient onDeselected={()=>setClient(0)} onSelected={data =>{setClient(data.id);console.log(data[0]);setClaimTicket(0)}}></SearchClient>
            );
        }
    }
    

useEffect(() => {
    setFetchedTypes([])
    setFetchedItems([])
    console.log(selectedItem.object_type)
    setSelectedItem((prev)=>({...prev,cantidad:1}))
    if (!selectedItem.object_type) return;

    switch (selectedItem.object_type) {
        case 'Accesorio':
            fetchData(API_URLS.ACCESORIES, (data) =>
                setFetchedTypes([...new Set(data.map(acc => acc.tipo))])
            );
            break;
        case 'Parte':
            fetchData(API_URLS.PARTS, (data) =>
                setFetchedTypes([...new Set(data.map(acc => acc.tipo))])
            );
            break;
        case 'Dron':
        case 'Drones':
            fetchData(API_URLS.DRONES, (data) =>
                setFetchedTypes([...new Set(data.filter(item => item.linea === type).map(acc => acc.serie))])
            );
            break;
 
        case 'Servicio':
            fetchData(API_URLS.SERVICES, (data) =>
                setFetchedItems([...new Set(data.filter(item => item.linea === type))])
            );
            setSelectedItem(prev=>({...prev,tipo:"N/A"}))
            break;
    }
}, [selectedItem.object_type,type]);
 
const renderAddItem = (object_type) => {
    
    switch (object_type) {
        case 'Accesorio':
            return(
              
            <div className="invisible-horizontal-container">
              
                    Tipo de {object_type.toLowerCase()}:
                    <DropdownSearch
                        
                        options={fetchedTypes}
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))}
                        keys={fetchedItems.map(item=>item.id)}
                        returnSelectedOption={(data) =>{
                            setSelectedItem((prev) => ({ ...prev, tipo: data }))
                            fetchData(API_URLS.ACCESORIES + "?tipo=" + data, (data) =>{setFetchedItems(data)})
                        }
                        }
                    />
                    Modelo:
                    <DropdownSearch 
                       
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,modelo:data,modelo:data, concepto: prev.tipo + " " + data, url:API_URLS.ACCESORIES}))} 
                        
                        options={fetchedItems.map((item)=>item.modelo)}/>
                </div>)
                break;
        case 'Parte':
            return (
                <div className="invisible-horizontal-container">
                    Tipo de {object_type.toLowerCase()}:
                    <DropdownSearch
                        
                        options={fetchedTypes}
                        returnSelectedOption={(data) =>{
                            setSelectedItem((prev) => ({ ...prev, tipo: data }))
                            fetchData(API_URLS.PARTS + "?tipo=" + data, (data) =>{setFetchedItems(data)})}
                        }
                    />
                    Modelo:
                    <DropdownSearch 
                        
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,modelo:data, concepto: prev.tipo + " " + data,url:API_URLS.PARTS}))} 
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        
                        options={fetchedItems.map((item)=>item.modelo)}/>
                </div>
            );
            break;
        case 'Dron':
            return (
                <div className="invisible-horizontal-container">
                    Serie:
                    <DropdownSearch 
                        
                        returnSelectedOption={(data)=>{
                          setSelectedItem(prev=>({...prev,serie:data}))
                          fetchData(API_URLS.DRONES + "?serie=" + data, (data) =>{setFetchedItems(data)})
                      }
                      } 
                        options={fetchedTypes} />
                    Modelo:
                    <DropdownSearch 
                        
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,modelo:data,concepto: prev.serie + " " + data,url:API_URLS.DRONES}))} 
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        options={fetchedItems.filter(item=>item.serie==selectedItem.serie).map((item)=>item.modelo)} 
                        />
                </div>
            );

        case 'Servicio':
            return (
                <div className="invisible-horizontal-container">
                    Concepto:
                    <DropdownSearch 
                        
                        returnSelectedKey={data=>setSelectedItem(prev=>({...prev,id:data}))} 
                        keys={fetchedItems.map(item=>item.id)} 
                        returnSelectedOption={data=>setSelectedItem(prev=>({...prev,nombre:data, concepto: data,url:API_URLS.SERVICES}))} 
                        options={fetchedItems.map((item)=>item.nombre)} 
                        />
                </div>
            );
        default:
            return null;
    }
};

    useEffect(()=>{
        if(saleorRepair=='Reparacion'){
            updatePosition(0,'R')
        } else {
            updatePosition(0,'V')
        }
    },[saleorRepair])
   
    useEffect(()=>{
        fetchNum(folio[0]+folio[1])
    },[folio])
    useEffect(()=>{
        if(type=='Enterprise'){
            updatePosition(1,'E')
        } else {
            updatePosition(1,'C')
        }
    },[type])
    useEffect(()=>{
        setRawTotal(itemList.reduce((sum, item) => sum + (item.precio*item.cantidad || 0), 0))
    },[itemList])
    useEffect(()=>{
        setTotal(rawTotal*(1-(discount*0.01)))
    },[discount,rawTotal])
    const fetchNum = (id) => { // Obtiene el numero de folio
        fetch(API_URLS.FOLIO +'?id='+id+'&year='+year, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(data => {
            setNum(String(data[0].num).padStart(3, '0'))
            
            })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    }
    const postData = (url, dataToSend, onSuccesful) => { // Envia los datos a la API
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    };
    return ( // Renderiza el componente
        <Popup title="Nueva Cotizacion" onClose={onClose}>
            <div className="header1">{(claimTicket!==0 || saleorRepair ==='Venta') &&(<div>Folio tentativo: {folio[0]+folio[1]+year+num}</div>)}</div>
            <div className="invisible-horizontal-container">
            Tipo:
            <Dropdown returnSelectedOption={(option)=>{setSaleorRepair(option)}} options={['Reparacion', 'Venta']}></Dropdown>
            {saleorRepair === 'Venta' && (<Dropdown returnSelectedOption={(option)=>{setType(option)}} options={['Comercial','Enterprise']}></Dropdown>)}
            </div>
            {setSaleRepair(saleorRepair)}
            <div className="header1">Agregar item</div>
            <div className="invisible-horizontal-container">
                { client &&client !=0  ? (
                    <div className="invisible-horizontal-container">
                    <Dropdown returnSelectedOption={(data) =>setSelectedItem((prev) => ({...prev,object_type: data,cantidad: 1 }))} options={['Servicio','Parte','Accesorio','Dron']}></Dropdown>
                    {selectedItem.object_type && (renderAddItem(selectedItem.object_type))}
                    Cantidad:
                    <input
                        type="number"
                        min={1}
                        defaultValue={1}
                        max={100}
                        // value={currentObject.cantidad || ''}
                        onChange={(data) => {
                            const value = data.target.value;
                            // Limitar a 3 caracteres y solo números
                            if (value.length <= 3 && /^\d*$/.test(value)) {
                                const numericValue = parseInt(value, 10);

                                // Asegurarse de que el valor esté dentro del rango permitido
                                if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                                    setSelectedItem((prev)=>({...prev,cantidad:numericValue}))
                                } else if (value === '') {
                                    setSelectedItem((prev)=>({...prev,cantidad:0}))
                                }}
                            }}
                    />
                    <Button text="Agregar" color="#318acc" onClick={()=>{
                        if(selectedItem.concepto){
                            console.log('Adding selected item:', selectedItem);
                            fetchData(selectedItem.url + "?id="+selectedItem.id,data=>{
                                setItemList(prev=>([...prev,{...selectedItem,precio:data[0].precio}]));
                                setRawTotal(rawTotal+(data[0].precio*selectedItem.cantidad));
                                
                        })   
                        } else {
                            alert('Seleccione todos los campos requeridos')
                        }}}/>
                    </div>
                ):(
                    
                    <div>
                        { saleorRepair == 'Reparacion' ?(
                            <div>Seleccione una nota de recepcion primero.</div>
                        ):(
                            <div>Seleccione un cliente primero.</div>
                        )}
                    </div>
                )}
            
            </div>
           
                <Table1 optdelete={true} onClickDelete={(data,index)=>{console.log(data);setItemList(itemList.filter(item=>item.id!=data.id)); }} headers={['Id','','Concepto','Precio unidad','Cantidad','Total']}data={itemList.map(item=>({id:item.id,objectype:item.object_type,concepto:item.concepto,precio:item.precio,cantidad:item.cantidad, total:item.precio * item.cantidad}))}></Table1>
            <div className="invisible-horizontal-container">
            {"Descuento sobre el total(%):"}
                    <input
                        type="number"
                        min={0}
                        defaultValue={0}
                        max={100}
                        // value={currentObject.cantidad || ''}
                        onChange={(data) => {
                            const value = data.target.value;
                            // Limitar a 3 caracteres y solo números
                            if (value.length <= 3 && /^\d*$/.test(value)) {
                                const numericValue = parseInt(value, 10);

                                // Asegurarse de que el valor esté dentro del rango permitido
                                if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 100) {
                                    setDiscount(numericValue)
                                    
                                } else if (value === '') {
                                   
                                    setDiscount(0)
                                }}
                            }}
                    />
            </div>
            <div className="invisible-horizontal-container">
            <div className="header1">Total: {total}</div>
            <div className="justify-right"><Button color={"#61BAA5"} text={"Agregar cotizacion"} onClick={()=>{
                if(saleorRepair==='Reparacion' && claimTicket===0){
                    alert('Por favor seleccione una nota de recepcion')
                } else if(saleorRepair==='Venta' && client===0){
                    alert('Por favor seleccione un cliente')
                } else {
                postData(API_URLS.COTIZATIONS,
            {
            folio:folio[0]+folio[1]+year+num,
            tipo:type,
            precio_total:total,
            descuento:discount,
            idCliente:client,
            fecha:formattedDate,
            notaRecepcion_id:claimTicket,
            year:year,
            id:folio[0]+folio[1],
            },async (data) => {
  try {
    for (const item of itemList) {
      await new Promise((resolve, reject) => {
        postData(API_URLS.BUDGETOBJECT, { ...item, tipo:item.object_type,item_id:item.id,custom_object_name:"",cotizacion_folio: folio[0]+folio[1]+year+num }, (res) => {
          if (res && !res.error) {
            resolve(res);
          } else {
            reject(res?.error || 'Error desconocido');
          }
        });
      });
    }

    onAccept(); // ✅ Run only after all POSTs succeed
  } catch (err) {
    console.error('Error al guardar los items:', err);
    alert('Hubo un problema al guardar los items de la cotización');
  }
}

            );}}}></Button></div></div>
            
        </Popup>
    )
}
export default NewBudget;